import { render } from "./SeoOmnyScoreCell.vue?vue&type=template&id=3c0ca9ec&scoped=true"
import script from "./SeoOmnyScoreCell.vue?vue&type=script&lang=js"
export * from "./SeoOmnyScoreCell.vue?vue&type=script&lang=js"

import "./SeoOmnyScoreCell.vue?vue&type=style&index=0&id=3c0ca9ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0ca9ec"]])

export default __exports__